import React, { useState } from 'react';
import { Calendar, MapPin, Search, Video, BookOpen, Moon, Instagram } from 'lucide-react';
import { Button } from "@/components/ui/button";

const Program = () => {
  const [filter, setFilter] = useState('');

  const programs = [
    {
      id: 1,
      title: "Live Streaming Kajian Rutin dan Tematik",
      description: "Simak kajian ilmu yang disiarkan langsung melalui berbagai platform media sosial Thuba.",
      date: "Jadwal Menyesuaikan",
      location: "Youtube",
      locationUrl: "https://www.youtube.com/@ThubaProject/streams",
      label: "Aktif",
      icon: Video
    },
    {
      id: 2,
      title: "Kelas online Muamalah Kontemporer",
      description: "Coming Soon. Program edukasi mendalam mengenai fiqih muamalah di era digital.",
      date: "Segera Hadir",
      location: "Zoom / GMeet",
      label: "Soon",
      icon: BookOpen
    },
    {
      id: 3,
      title: "Program Ramadhan Thuba Project",
      description: "Rangkaian program spesial Ramadhan: santunan dhuafa dan berbagi buka puasa.",
      date: "Ramadhan 1447 H",
      location: "Instagram @thubaproject",
      instagramUrl: "https://instagram.com/thubaproject/",
      label: "Ramadhan",
      icon: Moon
    },
    {
      id: 4,
      title: "Kajian Tematik dan Rutin Offline",
      description: "Kajian tematik dan kajian rutin sekitar masjid yang berada di Jakarta, Bekasi, dan Kabupaten Bogor.",
      date: "Jadwal Menyesuaikan",
      location: "Jakarta, Bekasi, & Bogor",
      label: "Offline",
      icon: MapPin
    }
  ];

  const filteredPrograms = programs.filter(p =>
    p.title.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="pt-24 min-h-screen bg-[#081c1a] animate-fade-in-up">
      <div className="container mx-auto px-6 py-12">
        <h1 className="text-5xl font-serif font-bold text-white mb-6 text-center">Program <span className="text-gold">Terkini</span></h1>

        {/* Search/Filter */}
        <div className="max-w-xl mx-auto mb-16 relative">
          <input
            type="text"
            placeholder="Cari program..."
            className="w-full bg-[#0D2B29] border border-white/10 rounded-full py-4 pl-12 pr-6 text-white focus:outline-none focus:border-gold/50"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <Search className="absolute left-4 top-4 text-muted-foreground w-5 h-5" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPrograms.map((prog, idx) => (
            <div key={idx} className="glass-card rounded-2xl overflow-hidden group flex flex-col">
              <div className="h-48 bg-gradient-to-br from-[#051211] to-[#0A2220] flex items-center justify-center">
                <div className="w-24 h-24 bg-gold/10 rounded-full flex items-center justify-center border border-gold/20">
                  <prog.icon className="w-12 h-12 text-gold" />
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="text-sm text-gold mb-2 font-medium">{prog.date}</div>
                <h3 className="text-2xl font-serif font-bold text-white mb-3 group-hover:text-gold transition-colors">{prog.title}</h3>
                <p className="text-muted-foreground mb-6 flex-1">{prog.description}</p>
                <div className="flex items-center text-sm text-muted-foreground mb-6">
                  <MapPin className="w-4 h-4 mr-2 text-gold" /> {prog.location}
                </div>
                {prog.instagramUrl ? (
                  <a href={prog.instagramUrl} target="_blank" rel="noopener noreferrer" className="w-full block">
                    <Button className="w-full bg-transparent border border-gold/30 text-gold hover:bg-gold hover:text-black flex items-center justify-center gap-2">
                      <Instagram className="w-4 h-4" /> Lihat Detail
                    </Button>
                  </a>
                ) : prog.locationUrl ? (
                  <a href={prog.locationUrl} target="_blank" rel="noopener noreferrer" className="w-full block">
                    <Button className="w-full bg-transparent border border-gold/30 text-gold hover:bg-gold hover:text-black">
                      Lihat Detail
                    </Button>
                  </a>
                ) : (
                  <Button className="w-full bg-transparent border border-gold/30 text-gold hover:bg-gold hover:text-black">
                    Lihat Detail
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Program;
